// Mirrors `@nesso/ui`'s `Command` default filter; duplicated because both service pickers run it
// themselves, in React, with `shouldFilter={false}` on `Command`, to keep their own trailing
// actions ("Add new service", "Add custom code") out of the filtered list.
export function getFilteredServiceOptions<T extends { code: string; description: string }>(
    options: T[],
    search: string,
): T[] {
    const query = search.trim().toLowerCase();
    if (!query) return options;
    return options.filter((option) =>
        `${option.code} ${option.description}`.toLowerCase().includes(query),
    );
}
